import { epic$, store } from '@redux/store';
import {
  postBuildablePlanBrochureEpic,
  postCommunityBrochureEpic,
  postPlanBrochureEpic,
  postSpecBrochureEpic,
  postRecommendedBrochureEpic,
  getRecommendedBrochureEpicPaid,
  getRecommendedBrochureEpicBasic,
  postSpecBrochureBasicEpic,
  postPlanBrochureBasicEpic,
  postCommunityBrochureBasicEpic,
  postBasicLisitingBrochureBasicEpic,
  getBrochureDownloadUrlEpic
} from './redux/epics';
import LeadFormType from './enums/leadFormType';
import brochureSlice from './redux/slices';
import { selectBrochureDetails } from './redux/selectors';


epic$.next(postBuildablePlanBrochureEpic);
epic$.next(postCommunityBrochureEpic);
epic$.next(postPlanBrochureEpic);
epic$.next(postSpecBrochureEpic);
epic$.next(postRecommendedBrochureEpic);
epic$.next(getRecommendedBrochureEpicPaid);
epic$.next(getRecommendedBrochureEpicBasic);
epic$.next(postSpecBrochureBasicEpic);
epic$.next(postPlanBrochureBasicEpic);
epic$.next(postCommunityBrochureBasicEpic);
epic$.next(postBasicLisitingBrochureBasicEpic);
epic$.next(getBrochureDownloadUrlEpic);

const { actions: brochureSliceActions, reducer: brochureSliceReducers } = brochureSlice;

require('./components/wrapper');
require('./components/pdfBrochureHandler');

store.injectReducer('brochureDownloadUrl', brochureSliceReducers);

export {
    brochureSliceActions,
    brochureSliceReducers,
    selectBrochureDetails
};

export default LeadFormType;